var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Copy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 10v42h-7.92v-4H61V14H29v4h-4v-8h40zM11 24h40v40H11V24zm4 36h32V28H15v32z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Copy.33f7f757.svg";
export { SvgJ2Copy as ReactComponent };